module.exports = __webpack_public_path__ + "static/media/logoSad.d3f1341e.svg";